import styled from 'styled-components'

export const CheckboxContainer = styled.div`
  padding: 10px 0px;
`

export const CertificatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 10px;
`
